import script from "./AccountMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountMobile.vue?vue&type=script&setup=true&lang=js"

import "./AccountMobile.vue?vue&type=style&index=0&id=2606cc5f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2606cc5f"]])

export default __exports__